var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',_vm._g(_vm._b({attrs:{"active-color":"#13ce66","inactive-color":"#ff4949","active-value":_vm.option[1].value,"inactive-value":_vm.option[0].value}},'el-switch',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }